import { Component, OnInit } from '@angular/core';
import {Constants} from '../../../../components/utils/constants'
import { HttpService } from '../../../../components/service/http.service';
import { BankProfile } from '../../../../components/utils/bank-profile';
import { BankDetailService } from '../../../../components/service/bank-detail.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { SharedTranslateModule } from '../../../../utils/sharedTranslateModule';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { EditbankprofileComponent } from '../editbankprofile/editbankprofile.component';
import { AddbankprofileComponent } from '../addbankprofile/addbankprofile.component';
import { RemovebankprofileComponent } from '../removebankprofile/removebankprofile.component';
import { PrintComponent } from '../print/print.component';
import { ProfileverificationComponent } from '../profileverification/profileverification.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { PayCopyComponent } from '../../../../components/pay copy/paycopy.component';
import { WindowRef } from '../../../../utils/window';
import { AuthorizationService } from '../../../../components/authorization/authorization.service';
import { SessionTimeoutComponent } from '../../../../../../src/app/components/sessionTimeout/sessionTimeout.component';

interface Payments {
  value: string;
  viewValue: string;
}

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'dtf-bankprofile',
    templateUrl: './bankprofile.component.html',
    styles: [],
    imports: [SharedTranslateModule, MatTableModule,SessionTimeoutComponent, MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, RouterModule, RouterLink
    ]
})
export class BankprofileComponent implements OnInit {
  
  manageBankProfileText= Constants.MANAGEBANKPROFILETEXT
  manageBankProfileSubText= Constants.MANAGEBANKPROFILESUBTEXT
  loaded: boolean;
  blocked: boolean;
  errmsg: any;
  thirdParty: string;
  saveProfileFalse: String;
  bankAcctCategory:String;
  constructor(private httpService: HttpService,public auth: AuthorizationService, private bankDetailService: BankDetailService, private router: Router, private _window: WindowRef) { 
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
  }

  dropDownList: Array<any>=[];
  bankDetailObj: BankProfile=new BankProfile;
  thirdPartyObject: string;

  selected: any;
  profiles:any;
  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];
  selectedPayment: string | null = null;
  azURL: string;
  usUrl: string;
  trans_history = false;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  ciamId = sessionStorage.getItem('loginID');

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

 


  onLoad(){
  this.dropDownList=[];
  const request = {
    "thirdPartyId" : this.thirdParty,
     "userId" : this.ciamId
  }
    this.auth.bankProfile(request).subscribe(res => {
     if(res.length==0){     
            sessionStorage.setItem('online-page-navigation', "Online-Payment")
            sessionStorage.setItem('userExist',"true")
            this.router.navigate(['/home/addprofile']);
          }else{
            sessionStorage.setItem('userExist',"false")
            this.profiles=res;
    
          this.profiles.forEach((element: any) => {
            let option=element.bankName+" "+element.maskedAccountNumber.substr(element.maskedAccountNumber.length - 4)
            let obj={selection: option, id:element.id}
            // if(element["saveProfile"]){
              this.dropDownList.push(obj);
            //   }
              this.selected=this.dropDownList[0]["id"];
          })
        
          this.bankDetailObj=this.profiles[0];
          this.bankDetailService.setObject(this.bankDetailObj);
          this.loaded=true;
        }
     
    }, error=>{ 
       if(error.status){
         this.errmsg=error.message
         this.blocked=true;
         this.loaded=true;
       }
  });
  }

  BacktoDashBoard(){
    this._window.nativeWindow.location.href = '/home/dashboard';
  }


  onChange(){
    let index=this.profiles.findIndex((obj:any)=>obj.id===this.selected)
    this.bankDetailObj=this.profiles[index];
    this.bankDetailService.setObject(this.bankDetailObj);

  }

  ngOnInit(): void {  
    this.saveProfileFalse = sessionStorage.getItem('saveProfileFasleObj');
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.thirdPartyObject = sessionStorage.getItem('thirdPartyObjectType');
    this.onLoad();
   // this.getUserInfo();

    if(this.thirdPartyObject == 'B'){
      this.bankAcctCategory = 'Business';
    }else{
      this.bankAcctCategory = 'Personal';
    }

  }
  // getUserInfo(){
  //   let tableURL = "getAccountList/1";
  //   this.httpService.getAccountsList(tableURL).subscribe((data: any) => {
  //     if(data){
  //       this.validateUser()
  //    this.onLoad();
  //       sessionStorage.setItem('userAccountInfo', JSON.stringify(data.truckAccountInfo))
  //     }
  //   }, error=>{
  //     if(error.status){
  //       this.errmsg=error.message
  //       this.blocked=true;
  //       this.loaded=true;
  //     }
  //   }
  //   )
  // }
  validateUser(){
    let URL="getBankProfileForUser"
    this.httpService.getRequest(URL).subscribe((data) => {
     if(data==true){
      sessionStorage.setItem('userExist',"false")
      this.onLoad();
     }else{

      sessionStorage.setItem('online-page-navigation', 'Online-Payment')
      sessionStorage.setItem('userExist',"true")
      let tableURL = "getAccountList/1";
      this.httpService.getAccountsList(tableURL).subscribe((data: any) => {
        if(data){
          sessionStorage.setItem('userAccountInfo', JSON.stringify(data.truckAccountInfo))
          this.router.navigate(['/home/addprofile']);
        }
        this.loaded=true;
      }, error=>{
        if(error.status){
          this.errmsg=error.message
          this.blocked=true;
          this.loaded=true;
        }
      }
      )
     
     }
    }, error=>{
      if(error.status){
        this.errmsg=error.message
        this.blocked=true;
        this.loaded=true;
      }
    }
    )

    }

}
